// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/downArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background: #ffffff;
  /* height: 100px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px;
  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
  border-top: 10px solid #977cff;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}

.navbar .logo {
  text-decoration: none;
  color: #122f48;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 20px;
  /* width: 15%; */
}

.navbar .logo img {
  width: 100%;
  height: 3vw;
}

/* nav menu button */

.menu-btn {
  position: relative;
  display: none;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  z-index: 2;
}

.navbar .menu-btn__lines::before,
.navbar .menu-btn__lines::after {
  content: "";
  position: absolute;
}

.navbar .menu-btn__lines,
.navbar .menu-btn__lines::before,
.navbar .menu-btn__lines::after {
  width: 1.5rem;
  height: 0.1rem;
  background: #132f48;
  transition: all 0.4s ease-in-out;
}

.navbar .menu-btn__lines::before {
  transform: translateY(-0.4rem);
}

.navbar .menu-btn__lines::after {
  transform: translateY(0.4rem);
}

.navbar .menu-items {
  display: flex;
  align-items: center;
  /* width: 65%; */
}

.navbar ul li {
  list-style: none;
  transition: 0.3s ease;
}

.navbar ul li .arrow {
  transition: all 0.3s ease-out;
}

.navbar ul li a {
  text-decoration: none;
  color: #112f48;
}

/* dropdown menu */

.navbar .dropdown {
  position: relative;
}

.expand-btn:after {
  content: "";
  opacity: 1;
  margin-left: 5px;
  display: block;
  width: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.dropdown .dropdown .expand-btn:after {
  transform: rotate(-90deg);
}

.navbar .dropdown-menu,
.menu-right {
  position: absolute;
  background: transparent;
  width: 220px;
  left: 0 !important;
  padding: 25px 0 0 0;
  line-height: 30px;
  border-radius: 0 0 20px 20px;
  border: 0;
  transition: all 0.4s ease;
  box-shadow: none;
}

.navbar .dropdown-menu li {
  list-style: none;
  transition: 0.1s ease;
  background: #ededfd;
  font-weight: 500;
}

.navbar .dropdown-menu,
.menu-right {
  transition: 0.1s ease;
}

.navbar .dropdown-menu li:hover {
  background: var(--dBlue);
}
.navbar ul li ul li:hover a {
  color: white;
}

.navbar .menu-right {
  top: -35px;
  left: 100% !important;
  visibility: hidden;
}

.navbar .dropdown .dropdown-right:hover .menu-right {
  visibility: visible;
}

.navbar .dropdown .dropdown-right:hover .menu-right li a {
  color: #000;
}

.navbar .dropdown .dropdown-right:hover .menu-right li:hover a {
  color: #fff;
}

.navbar .dropdown-menu,
.menu-left {
  left: auto;
  left: initial;
  right: 0;
}

.navbar .menu-left {
  left: -100%;
}

.navbar .menu-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 1.5rem;
  font-size: 14px;
  text-align: center;
}

.navbar .dropdown-menu.sample .menu-item:hover {
  background: #7380ff;
  color: #fff;
}

.menu-item.first-item {
  padding: 0 1rem;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
}

.navbar .dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  display: block;
  overflow: visible;
}

.navbar .dropdown .dropdown-right:hover .menu-right {
  left: 100%;
  opacity: 1;
  visibility: visible;
  top: 0;
  padding: 0;
}

.navbar .dropdown-right:hover .menu-left {
  left: -100%;
}

/* mega menu  */

.navbar .mega-menu {
  position: absolute;
  left: 0;
  width: 100vw;
  top: 65px;
  border-top: 1px solid #ffffff;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease-out 0s, visibility 0.1s linear 0s;
}

.mega-menu .content {
  background: #e9ecef;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);
}

.blog .content {
  grid-template-columns: repeat(4, 1fr);
}

.content .col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 3rem;
}

.content .col .img-wrapper {
  display: block;
  position: relative;
  width: 100%;
  height: 20vw;
  overflow: hidden;
}

.content .col .img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.content .col img {
  width: 100%;
  transition: transform 0.3s ease-in-out;
}

.content .col .img-wrapper:hover img {
  transform: scale(1.1);
}

.content .col .menu-title {
  color: #ff5722;
  font-size: 1.2rem;
  line-height: 3rem;
  font-weight: bold;
}

.content .col p {
  line-height: 1.2rem;
  margin-top: 5px;
  color: #112f48;
}

.content .col .mega-links {
  border-left: 1px solid #3c3c3c;
}

.content .col .read-more {
  font-size: 16px;
  display: flex;
  padding-top: 1rem;
  color: #03a9f4;
  transition: color 0.3s ease;
  justify-content: flex-end;
  padding-right: 10px;
}

.col .mega-links li,
.col .mega-links li a {
  padding: 0 1rem;
}

.menu-items li:hover .mega-menu {
  opacity: 1;
  visibility: visible;
}

.content .col .read-more:hover {
  color: #ff5722;
}

/* container */

/* animation menu hamburger */
.menu-btn.open .menu-btn__lines {
  transform: translateX(1rem);
  background: transparent;
}

.menu-btn.open .menu-btn__lines::before {
  transform: rotate(45deg) translate(-0.5rem, 0.5rem);
  background: #132f48;
}

.menu-btn.open .menu-btn__lines::after {
  transform: rotate(-45deg) translate(-0.5rem, -0.5rem);
  background: #132f48;
}

.right-nav-wrapper-mob {
  display: none;
}

/* Responsive style */

.profile-ul {
  flex-direction: column;
  background: #ededfd;
  position: absolute;
  margin: 10px;
  width: 130px;
  padding: 0px;
}

.profile-ul li {
  font-size: 14px;
  margin-bottom: 10px;
  padding: 10px 20px;
  width: 100%;
  /* text-transform: uppercase; */
}

.profile-ul li:hover {
  background: #7380ff;
  color: #fff;
}

.login-btn {
  font-size: 18px;
  font-weight: 500;
  display: inline-block;
  border: 2px solid var(--dPink);
  padding: 6px 30px;
  border-radius: 25px;
}

.navbar .menu-items {
  margin-bottom: 0;
}
.footer_icons {
  margin-left: 50px;
}

.smk-container {
  padding: 0 3%;
}

@media (max-width: 576px) {
  .navbar .menu-items {
    width: 80%;
  }
  .navbar .menu-items {
    top: 50px;
  }

  .login-header {
    margin-left: 70px;
  }

  .login-header .uniBtn {
    padding: 0 20px;
    line-height: 2;
  }
}

@media screen and (max-width: 1024px) {
  .navbar {
    padding: 10px 20px;
  }

  .overflow {
    overflow: hidden;
  }

  .overlay {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 500;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  .overlay--active {
    opacity: 1;
    visibility: visible;
  }

  .menu-btn {
    display: flex;
    order: 1;
  }

  .navbar .menu-items {
    position: fixed;
    height: 100%;
    max-height: none;
    max-height: initial;
    overflow-y: auto;
    /* width: 80%; */
    top: 50px;
    left: 0;
    background: #fcfcfc;
    display: block;
    transform: translateX(-100vh);
    transition: 0.3s ease-out;
    padding-bottom: 100px;
  }
  .navbar ul li a {
    padding: 5px 0px 0px 0px;
  }
  .menu-items.open {
    transform: translateY(0);
  }

  .menu-items li:first-child {
    /* margin-top: 20px; */
  }

  .menu-items li a {
    padding: 10px 1rem;
    display: block;
    font-size: 18px;
  }

  .menu-items .dropdown-right .right-arrow {
    transform: rotate(90deg);
  }

  .menu-item.first-item {
    padding: 1rem 1rem;
  }

  /* DROPDOWN, MEGA MENUS */
  .menu-items .dropdown-menu,
  .menu-items .menu-right,
  .menu-items .mega-menu {
    position: static;
    opacity: 1;
    top: 4rem;
    visibility: visible;
    margin-left: -18px;
    width: auto;
    max-height: 0;
    transform: scaleX(0);
    transform-origin: left;
    overflow: hidden;
    transition: all 0.5s ease;
  }

  .menu-items .dropdown-menu,
  .menu-items .menu-right {
    padding-left: 1rem;
    width: 102%;
    margin-left: 0px;
    border-radius: 0px;
  }
  .menu-items .menu-right li {
    padding-left: 20px;
  }
  .navbar .dropdown-menu,
  .menu-right {
    padding: 0px;
  }

  .menu-items .mega-menu .col {
    padding-left: 1rem;
  }

  .expand-btn.open + .sample {
    max-height: 100%;
    transform: scaleZ(1);
  }

  .expand-btn.open + .blog.sample {
    max-height: 100%;
    transform: scaleZ(1);
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }

  .navbar .sample {
    border-top: none;
  }

  .sample li {
    margin: 0;
  }

  .sample li:last-child {
    border-bottom: none;
  }

  .sample li a {
    font-size: 1rem;
  }

  .mega-menu .content {
    grid-template-columns: auto;
    padding: 1rem 1rem 0 1rem;
  }

  .mega-menu .content .col {
    width: 100%;
    padding-top: 1rem;
    margin-bottom: 0.5rem;
  }

  .col .mega-links li,
  .col .mega-links li a {
    padding: 0 0.5rem;
  }

  .content .col .mega-links {
    border-left: 0;
    padding-left: 0.5rem;
  }

  .col .mega-links li {
    margin: 0;
  }

  /* .right-nav-wrapper {
    display: none;
  } */

  .right-nav-wrapper-mob {
    display: block;
  }

  .navbar .logo {
    /* width: 50%; */
  }
  .navbar .logo img {
    width: 180%;
  }
}

.right-nav-wrapper ul {
  list-style: none;
  display: flex;
  column-gap: 8px;
  margin-bottom: 0;
}

.right-nav-wrapper ul li a.right-nav-icon {
  font-size: 26px;
  color: var(--dPink);
}

.right-nav-wrapper-mob {
  position: absolute;
  bottom: 60px;
}

.right-nav-wrapper-mob ul {
  list-style: none;
  display: flex;
  column-gap: 10px;
  align-items: baseline;
  justify-content: center;
  padding: 0px;
}

.right-nav-wrapper-mob ul li a.right-nav-icon {
  font-size: 26px;
  color: var(--dPink);
}

.cart-count {
  position: absolute;
  background: var(--dBlue);
  font-size: 12px;
  width: 15px;
  height: 15px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  right: -5px;
  top: 1px;
}

.welcome-text {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}

.welcome-text p {
  margin: 0;
  padding: 0;
  background: var(--dBlue);
  color: #fff;
  padding: 5px 25px;
  height: auto;
  border-radius: 40px;
}

.dropdown-menu {
  transition-duration: 0.2s !important;
}

.power-btn {
  font-size: 22px;
}

.right-nav-wrapper ul li a svg {
  stroke-width: 0.8px;
}

@media only screen and (min-width: 576px) and (max-width: 992px) {
  .navbar .logo img {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .navbar {
    padding: 10px 15px;
  }

  .right-nav-wrapper ul {
    padding-left: 0px;
    column-gap: 8px;
  }
  .navbar .logo img {
    width: 100%;
    height: 15px;
  }

  .welcome-text p {
    padding: 2px 20px;
    font-size: 12px;
  }

  .right-nav-wrapper ul li a.right-nav-icon,
  .power-btn {
    font-size: 20px;
  }

  .cart-count {
    font-size: 12px;
    width: 15px;
    height: 15px;
    right: -5px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .menu-item.first-item {
    padding: 0 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/Header3.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAElB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yDAAwD;EACxD,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAW;EAAX,aAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;;AAEf;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,WAAW;EACX,8BAA8B;EAE9B,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;;AAEd,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,qBAAqB;;AAErB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,oCAAoC;IACpC,UAAU;IACV,kBAAkB;IAClB,iEAAiE;EACnE;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;;;IAGE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,8BAAsB;IAAtB,2BAAsB;IAAtB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;;KAEG;;EAEH;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EAEb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".navbar {\n  background: #ffffff;\n  /* height: 100px; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 30px;\n  -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);\n  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);\n  border-top: 10px solid #977cff;\n}\n\n.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n}\n\n.navbar .logo {\n  text-decoration: none;\n  color: #122f48;\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 20px;\n  /* width: 15%; */\n}\n\n.navbar .logo img {\n  width: 100%;\n  height: 3vw;\n}\n\n/* nav menu button */\n\n.menu-btn {\n  position: relative;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.navbar .menu-btn__lines::before,\n.navbar .menu-btn__lines::after {\n  content: \"\";\n  position: absolute;\n}\n\n.navbar .menu-btn__lines,\n.navbar .menu-btn__lines::before,\n.navbar .menu-btn__lines::after {\n  width: 1.5rem;\n  height: 0.1rem;\n  background: #132f48;\n  transition: all 0.4s ease-in-out;\n}\n\n.navbar .menu-btn__lines::before {\n  transform: translateY(-0.4rem);\n}\n\n.navbar .menu-btn__lines::after {\n  transform: translateY(0.4rem);\n}\n\n.navbar .menu-items {\n  display: flex;\n  align-items: center;\n  /* width: 65%; */\n}\n\n.navbar ul li {\n  list-style: none;\n  transition: 0.3s ease;\n}\n\n.navbar ul li .arrow {\n  transition: all 0.3s ease-out;\n}\n\n.navbar ul li a {\n  text-decoration: none;\n  color: #112f48;\n}\n\n/* dropdown menu */\n\n.navbar .dropdown {\n  position: relative;\n}\n\n.expand-btn:after {\n  content: \"\";\n  opacity: 1;\n  margin-left: 5px;\n  display: block;\n  width: 10px;\n  background-image: url(../../public/images/downArrow.svg);\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.dropdown .dropdown .expand-btn:after {\n  transform: rotate(-90deg);\n}\n\n.navbar .dropdown-menu,\n.menu-right {\n  position: absolute;\n  background: transparent;\n  width: 220px;\n  left: 0 !important;\n  padding: 25px 0 0 0;\n  line-height: 30px;\n  border-radius: 0 0 20px 20px;\n  border: 0;\n  transition: all 0.4s ease;\n  box-shadow: none;\n}\n\n.navbar .dropdown-menu li {\n  list-style: none;\n  transition: 0.1s ease;\n  background: #ededfd;\n  font-weight: 500;\n}\n\n.navbar .dropdown-menu,\n.menu-right {\n  transition: 0.1s ease;\n}\n\n.navbar .dropdown-menu li:hover {\n  background: var(--dBlue);\n}\n.navbar ul li ul li:hover a {\n  color: white;\n}\n\n.navbar .menu-right {\n  top: -35px;\n  left: 100% !important;\n  visibility: hidden;\n}\n\n.navbar .dropdown .dropdown-right:hover .menu-right {\n  visibility: visible;\n}\n\n.navbar .dropdown .dropdown-right:hover .menu-right li a {\n  color: #000;\n}\n\n.navbar .dropdown .dropdown-right:hover .menu-right li:hover a {\n  color: #fff;\n}\n\n.navbar .dropdown-menu,\n.menu-left {\n  left: unset;\n  right: 0;\n}\n\n.navbar .menu-left {\n  left: -100%;\n}\n\n.navbar .menu-item {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.5rem 1.5rem;\n  font-size: 14px;\n  text-align: center;\n}\n\n.navbar .dropdown-menu.sample .menu-item:hover {\n  background: #7380ff;\n  color: #fff;\n}\n\n.menu-item.first-item {\n  padding: 0 1rem;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.navbar .dropdown:hover .dropdown-menu {\n  opacity: 1;\n  visibility: visible;\n  display: block;\n  overflow: visible;\n}\n\n.navbar .dropdown .dropdown-right:hover .menu-right {\n  left: 100%;\n  opacity: 1;\n  visibility: visible;\n  top: 0;\n  padding: 0;\n}\n\n.navbar .dropdown-right:hover .menu-left {\n  left: -100%;\n}\n\n/* mega menu  */\n\n.navbar .mega-menu {\n  position: absolute;\n  left: 0;\n  width: 100vw;\n  top: 65px;\n  border-top: 1px solid #ffffff;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.4s ease-out 0s, visibility 0.1s linear 0s;\n}\n\n.mega-menu .content {\n  background: #e9ecef;\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  width: 100%;\n  justify-content: space-between;\n  -webkit-box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);\n  box-shadow: 0 20px 50px 0 rgb(0 0 0 / 5%);\n}\n\n.blog .content {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.content .col {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  line-height: 3rem;\n}\n\n.content .col .img-wrapper {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 20vw;\n  overflow: hidden;\n}\n\n.content .col .img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.content .col img {\n  width: 100%;\n  transition: transform 0.3s ease-in-out;\n}\n\n.content .col .img-wrapper:hover img {\n  transform: scale(1.1);\n}\n\n.content .col .menu-title {\n  color: #ff5722;\n  font-size: 1.2rem;\n  line-height: 3rem;\n  font-weight: bold;\n}\n\n.content .col p {\n  line-height: 1.2rem;\n  margin-top: 5px;\n  color: #112f48;\n}\n\n.content .col .mega-links {\n  border-left: 1px solid #3c3c3c;\n}\n\n.content .col .read-more {\n  font-size: 16px;\n  display: flex;\n  padding-top: 1rem;\n  color: #03a9f4;\n  transition: color 0.3s ease;\n  justify-content: flex-end;\n  padding-right: 10px;\n}\n\n.col .mega-links li,\n.col .mega-links li a {\n  padding: 0 1rem;\n}\n\n.menu-items li:hover .mega-menu {\n  opacity: 1;\n  visibility: visible;\n}\n\n.content .col .read-more:hover {\n  color: #ff5722;\n}\n\n/* container */\n\n/* animation menu hamburger */\n.menu-btn.open .menu-btn__lines {\n  transform: translateX(1rem);\n  background: transparent;\n}\n\n.menu-btn.open .menu-btn__lines::before {\n  transform: rotate(45deg) translate(-0.5rem, 0.5rem);\n  background: #132f48;\n}\n\n.menu-btn.open .menu-btn__lines::after {\n  transform: rotate(-45deg) translate(-0.5rem, -0.5rem);\n  background: #132f48;\n}\n\n.right-nav-wrapper-mob {\n  display: none;\n}\n\n/* Responsive style */\n\n.profile-ul {\n  flex-direction: column;\n  background: #ededfd;\n  position: absolute;\n  margin: 10px;\n  width: 130px;\n  padding: 0px;\n}\n\n.profile-ul li {\n  font-size: 14px;\n  margin-bottom: 10px;\n  padding: 10px 20px;\n  width: 100%;\n  /* text-transform: uppercase; */\n}\n\n.profile-ul li:hover {\n  background: #7380ff;\n  color: #fff;\n}\n\n.login-btn {\n  font-size: 18px;\n  font-weight: 500;\n  display: inline-block;\n  border: 2px solid var(--dPink);\n  padding: 6px 30px;\n  border-radius: 25px;\n}\n\n.navbar .menu-items {\n  margin-bottom: 0;\n}\n.footer_icons {\n  margin-left: 50px;\n}\n\n.smk-container {\n  padding: 0 3%;\n}\n\n@media (max-width: 576px) {\n  .navbar .menu-items {\n    width: 80%;\n  }\n  .navbar .menu-items {\n    top: 50px;\n  }\n\n  .login-header {\n    margin-left: 70px;\n  }\n\n  .login-header .uniBtn {\n    padding: 0 20px;\n    line-height: 2;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .navbar {\n    padding: 10px 20px;\n  }\n\n  .overflow {\n    overflow: hidden;\n  }\n\n  .overlay {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 500;\n    background-color: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n  }\n\n  .overlay--active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .menu-btn {\n    display: flex;\n    order: 1;\n  }\n\n  .navbar .menu-items {\n    position: fixed;\n    height: 100%;\n    max-height: initial;\n    overflow-y: auto;\n    /* width: 80%; */\n    top: 50px;\n    left: 0;\n    background: #fcfcfc;\n    display: block;\n    transform: translateX(-100vh);\n    transition: 0.3s ease-out;\n    padding-bottom: 100px;\n  }\n  .navbar ul li a {\n    padding: 5px 0px 0px 0px;\n  }\n  .menu-items.open {\n    transform: translateY(0);\n  }\n\n  .menu-items li:first-child {\n    /* margin-top: 20px; */\n  }\n\n  .menu-items li a {\n    padding: 10px 1rem;\n    display: block;\n    font-size: 18px;\n  }\n\n  .menu-items .dropdown-right .right-arrow {\n    transform: rotate(90deg);\n  }\n\n  .menu-item.first-item {\n    padding: 1rem 1rem;\n  }\n\n  /* DROPDOWN, MEGA MENUS */\n  .menu-items .dropdown-menu,\n  .menu-items .menu-right,\n  .menu-items .mega-menu {\n    position: static;\n    opacity: 1;\n    top: 4rem;\n    visibility: visible;\n    margin-left: -18px;\n    width: auto;\n    max-height: 0;\n    transform: scaleX(0);\n    transform-origin: left;\n    overflow: hidden;\n    transition: all 0.5s ease;\n  }\n\n  .menu-items .dropdown-menu,\n  .menu-items .menu-right {\n    padding-left: 1rem;\n    width: 102%;\n    margin-left: 0px;\n    border-radius: 0px;\n  }\n  .menu-items .menu-right li {\n    padding-left: 20px;\n  }\n  .navbar .dropdown-menu,\n  .menu-right {\n    padding: 0px;\n  }\n\n  .menu-items .mega-menu .col {\n    padding-left: 1rem;\n  }\n\n  .expand-btn.open + .sample {\n    max-height: 100%;\n    transform: scaleZ(1);\n  }\n\n  .expand-btn.open + .blog.sample {\n    max-height: 100%;\n    transform: scaleZ(1);\n    max-width: fit-content;\n  }\n\n  .navbar .sample {\n    border-top: none;\n  }\n\n  .sample li {\n    margin: 0;\n  }\n\n  .sample li:last-child {\n    border-bottom: none;\n  }\n\n  .sample li a {\n    font-size: 1rem;\n  }\n\n  .mega-menu .content {\n    grid-template-columns: auto;\n    padding: 1rem 1rem 0 1rem;\n  }\n\n  .mega-menu .content .col {\n    width: 100%;\n    padding-top: 1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .col .mega-links li,\n  .col .mega-links li a {\n    padding: 0 0.5rem;\n  }\n\n  .content .col .mega-links {\n    border-left: 0;\n    padding-left: 0.5rem;\n  }\n\n  .col .mega-links li {\n    margin: 0;\n  }\n\n  /* .right-nav-wrapper {\n    display: none;\n  } */\n\n  .right-nav-wrapper-mob {\n    display: block;\n  }\n\n  .navbar .logo {\n    /* width: 50%; */\n  }\n  .navbar .logo img {\n    width: 180%;\n  }\n}\n\n.right-nav-wrapper ul {\n  list-style: none;\n  display: flex;\n  column-gap: 8px;\n  margin-bottom: 0;\n}\n\n.right-nav-wrapper ul li a.right-nav-icon {\n  font-size: 26px;\n  color: var(--dPink);\n}\n\n.right-nav-wrapper-mob {\n  position: absolute;\n  bottom: 60px;\n}\n\n.right-nav-wrapper-mob ul {\n  list-style: none;\n  display: flex;\n  -webkit-column-gap: 10px;\n  column-gap: 10px;\n  align-items: baseline;\n  justify-content: center;\n  padding: 0px;\n}\n\n.right-nav-wrapper-mob ul li a.right-nav-icon {\n  font-size: 26px;\n  color: var(--dPink);\n}\n\n.cart-count {\n  position: absolute;\n  background: var(--dBlue);\n  font-size: 12px;\n  width: 15px;\n  height: 15px;\n  text-align: center;\n  border-radius: 50%;\n  color: #fff;\n  right: -5px;\n  top: 1px;\n}\n\n.welcome-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 5px;\n}\n\n.welcome-text p {\n  margin: 0;\n  padding: 0;\n  background: var(--dBlue);\n  color: #fff;\n  padding: 5px 25px;\n  height: auto;\n  border-radius: 40px;\n}\n\n.dropdown-menu {\n  transition-duration: 0.2s !important;\n}\n\n.power-btn {\n  font-size: 22px;\n}\n\n.right-nav-wrapper ul li a svg {\n  stroke-width: 0.8px;\n}\n\n@media only screen and (min-width: 576px) and (max-width: 992px) {\n  .navbar .logo img {\n    width: 100%;\n  }\n}\n\n@media (max-width: 576px) {\n  .navbar {\n    padding: 10px 15px;\n  }\n\n  .right-nav-wrapper ul {\n    padding-left: 0px;\n    column-gap: 8px;\n  }\n  .navbar .logo img {\n    width: 100%;\n    height: 15px;\n  }\n\n  .welcome-text p {\n    padding: 2px 20px;\n    font-size: 12px;\n  }\n\n  .right-nav-wrapper ul li a.right-nav-icon,\n  .power-btn {\n    font-size: 20px;\n  }\n\n  .cart-count {\n    font-size: 12px;\n    width: 15px;\n    height: 15px;\n    right: -5px;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .menu-item.first-item {\n    padding: 0 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
